var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	12466: {
		fallback: () => (__webpack_require__.e(3696).then(() => (() => (__webpack_require__(63696))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "19.3.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	96460: {
		fallback: () => (__webpack_require__.e(706).then(() => (() => (__webpack_require__(78325))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "19.3.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	14329: {
		fallback: () => (__webpack_require__.e(7470).then(() => (() => (__webpack_require__(7470))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "19.3.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom/client",

	},
	85819: {
		fallback: () => (__webpack_require__.e(1198).then(() => (() => (__webpack_require__(41198))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^0.4.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "reflux",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"2454": [
		14329,
		85819
	],
	"2466": [
		12466
	],
	"6460": [
		96460
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}